import { copy } from '../content/copy';
import { Marginalia } from '../components/Marginalia';
import { SectionLabel } from '../components/SectionLabel';

export function Method() {
  const { method } = copy;
  return (
    <section id="method" className="bg-l-paper-soft bg-math-pattern px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px] grid grid-cols-1 md:grid-cols-[7fr_5fr] gap-12 md:gap-16">
        <div>
          <SectionLabel>РАЗДЕЛ 02 · МЕТОДИКА</SectionLabel>
          <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-10">
            {method.title}
          </h2>
          <ol className="flex flex-col gap-8">
            {method.steps.map((s, i) => (
              <li key={s.n} className="flex gap-5">
                <div className="flex-shrink-0 flex flex-col items-center">
                  <span className="font-display text-l-terracotta text-3xl leading-none">{s.n}</span>
                  {i < method.steps.length - 1 && (
                    <span className="mt-2 w-px h-full bg-l-rule border-l border-dashed border-l-rule" aria-hidden />
                  )}
                </div>
                <div>
                  <h3 className="font-display text-l-ink-deep text-xl mb-2">{s.title}</h3>
                  <p className="font-sans text-l-ink text-[16px] leading-[1.6]">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="md:pt-20 flex flex-col gap-10">
          <Marginalia>{method.marginalia}</Marginalia>

          <div className="flex gap-8 py-6 border-y border-l-rule">
            <div className="flex flex-col gap-1">
              <div className="font-display font-normal text-l-ink-deep text-5xl leading-none tracking-tight tabular-nums">2ч</div>
              <div className="font-sans text-l-ink-muted text-[11px] uppercase tracking-[0.12em] leading-snug">в неделю</div>
            </div>
            <div className="flex flex-col gap-1">
              <div className="font-display font-normal text-l-ink-deep text-5xl leading-none tracking-tight tabular-nums">3–6</div>
              <div className="font-sans text-l-ink-muted text-[11px] uppercase tracking-[0.12em] leading-snug">месяцев до<br/>ощутимого<br/>результата</div>
            </div>
          </div>

          <Marginalia>{method.marginaliaSecondary}</Marginalia>
        </div>
      </div>
    </section>
  );
}
